import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Accordion from '../atoms/Accordion';
import Ranks, { RanksType } from '../atoms/Ranks';
import Player from '../types/Player';
import Team from '../types/Team';
import Position from '../types/Position';
import get from 'lodash/get';
import { getEventName } from '../services/event-names-and-formats';
import { RanksComparisonGroup } from './RanksTooltip';
import { UpdatedPlayerPPIStats } from '../types/PlayerPPIStats';

interface PPIChartsDataProps {
    className?: string;
    player?: Player;
    collegeTeam?: Team;
    nflTeam?: Team;
    position?: Position;
    onYearClick?: (year: number) => void;
    isNFL?: boolean;
}

const MOCKED_API_RESPONSE = [{
    "year":2025,
    "ppis":[{
        "name": "Overall PPI",
        "value": 3.5,
        "hsClassStats":{
            "percentile":98.22888283378747,
            "playerRank":27,
            "playerCount":1468
        },
        "div1Stats":{
            "percentile":89.84406237504999,
            "playerRank":509,
            "playerCount":5002
        },
        "teamStats":{
            "percentile":74.19354838709677,
            "playerRank":9,
            "playerCount":31
        },
        "conferenceStats":{
            "percentile":77.82340862422998,
            "playerRank":109,
            "playerCount":487
        },
        "nflDraftStats":{
            "percentile":67.63636363636364,
            "playerRank":90,
            "playerCount":275
        },
        "factors": [{
            "name": "Efficiency",
            "value": 4.2,
            "total": 5
        }, {
            "name": "Touchdowns",
            "value": 1.9,
            "total": 5
        }, {
            "name": "INTs",
            "value": 4,
            "total": 5
        }, {
            "name": "Explosiveness",
            "value": 2.1,
            "total": 5
        }],
        "prcentileFBS": 88,
        "utilization":101,
        "utilizationType": "High",
        "teamFactors": [
            "Played the #50 hardest defenses (out of 136 teams).",
            "Played on the #16 best offense (out of 136 teams)."
        ]
    },{
        "name": "Passing PPI",
        "value": 3.5,
        "hsClassStats":{
            "percentile":98.22888283378747,
            "playerRank":27,
            "playerCount":1468
        },
        "div1Stats":{
            "percentile":89.84406237504999,
            "playerRank":509,
            "playerCount":5002
        },
        "teamStats":{
            "percentile":74.19354838709677,
            "playerRank":9,
            "playerCount":31
        },
        "conferenceStats":{
            "percentile":77.82340862422998,
            "playerRank":109,
            "playerCount":487
        },
        "nflDraftStats":{
            "percentile":67.63636363636364,
            "playerRank":90,
            "playerCount":275
        },
        "factors": [{
            "name": "Efficiency",
            "value": 4.2,
            "total": 5
        }, {
            "name": "Touchdowns",
            "value": 1.9,
            "total": 5
        }, {
            "name": "INTs",
            "value": 4,
            "total": 5
        }, {
            "name": "Explosiveness",
            "value": 2.1,
            "total": 5
        }],
        "prcentileFBS": 88,
        "utilization":101,
        "utilizationType": "High",
        "teamFactors": [
            "Played the #50 hardest defenses (out of 136 teams).",
            "Played on the #16 best offense (out of 136 teams)."
        ]
    },{
        "name": "Rushing PPI",
        "value": 3.5,
        "hsClassStats":{
            "percentile":98.22888283378747,
            "playerRank":27,
            "playerCount":1468
        },
        "div1Stats":{
            "percentile":89.84406237504999,
            "playerRank":509,
            "playerCount":5002
        },
        "teamStats":{
            "percentile":74.19354838709677,
            "playerRank":9,
            "playerCount":31
        },
        "conferenceStats":{
            "percentile":77.82340862422998,
            "playerRank":109,
            "playerCount":487
        },
        "nflDraftStats":{
            "percentile":67.63636363636364,
            "playerRank":90,
            "playerCount":275
        },
        "factors": [{
            "name": "Power",
            "value": 1.9,
            "total": 5

        },{
            "name": "Efficiency",
            "value": 4.2,
            "total": 5
        }, {
            "name": "Explosiveness",
            "value": 2.1,
            "total": 5
        }],
        "prcentileFBS": 88,
        "utilization":101,
        "utilizationType": "High",
        "teamFactors": [
            "Played the #50 hardest defenses (out of 136 teams).",
            "Played on the #16 best offense (out of 136 teams)."
        ]
    },{
        "name": "Receiving PPI",
        "value": 3.5,
        "hsClassStats":{
            "percentile":98.22888283378747,
            "playerRank":27,
            "playerCount":1468
        },
        "div1Stats":{
            "percentile":89.84406237504999,
            "playerRank":509,
            "playerCount":5002
        },
        "teamStats":{
            "percentile":74.19354838709677,
            "playerRank":9,
            "playerCount":31
        },
        "conferenceStats":{
            "percentile":77.82340862422998,
            "playerRank":109,
            "playerCount":487
        },
        "nflDraftStats":{
            "percentile":67.63636363636364,
            "playerRank":90,
            "playerCount":275
        },
        "factors": [{
            "name": "Reliability",
            "value": 1.9,
            "total": 5
        }, {
            "name": "Impactfulness",
            "value": 4,
            "total": 5
        }, {
            "name": "Explosiveness",
            "value": 2.1,
            "total": 5
        }],
        "prcentileFBS": 88,
        "utilization":101,
        "utilizationType": "High",
        "teamFactors": [
            "Played the #50 hardest defenses (out of 136 teams).",
            "Played on the #16 best offense (out of 136 teams)."
        ]
    },{
        "name": "Blocking PPI",
        "value": 3.5,
        "hsClassStats":{
            "percentile":98.22888283378747,
            "playerRank":27,
            "playerCount":1468
        },
        "div1Stats":{
            "percentile":89.84406237504999,
            "playerRank":509,
            "playerCount":5002
        },
        "teamStats":{
            "percentile":74.19354838709677,
            "playerRank":9,
            "playerCount":31
        },
        "conferenceStats":{
            "percentile":77.82340862422998,
            "playerRank":109,
            "playerCount":487
        },
        "nflDraftStats":{
            "percentile":67.63636363636364,
            "playerRank":90,
            "playerCount":275
        },
        "factors": [{
            "name": "Run Blocking",
            "value": 4.2,
            "total": 5
        }, {
            "name": "Pass Blocking",
            "value": 1.9,
            "total": 5
        }],
        "prcentileFBS": 88,
        "utilization":101,
        "utilizationType": "High",
        "teamFactors": [
            "Played the #50 hardest defenses (out of 136 teams).",
            "Played on the #16 best offense (out of 136 teams)."
        ]
    }
    ]
}
]

const useStyles = makeStyles((theme: Theme) => ({
    addRemoveColumns: {
        marginBottom: theme.spacing(2),
    },
  yearsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    overflowX: 'auto',
    paddingBottom: theme.spacing(1),
    WebkitOverflowScrolling: 'touch',
  },
  yearButton: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0.75, 2),
    minWidth: 96,
    borderRadius: 999,
    border: '2px solid transparent',
    backgroundColor: '#f3f3f3',
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    whiteSpace: 'nowrap',
    fontSize: theme.typography.pxToRem(14),
    '&:hover': {
      backgroundColor: '#e9eef9',
    },
  },
  yearButtonSelected: {
    borderColor: '#0f89e6',
    backgroundColor: '#eff6ff',
  },
  yearLabel: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  scorePill: {
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 999,
    backgroundColor: '#0f89e6',
    color: '#ffffff',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    minWidth: 44,
    textAlign: 'center',
  },
  ppiWrapper: {
    marginTop: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: '#ffffff',
    padding: theme.spacing(2.5, 3),
    boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  ppiTopRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  ppiScoreCircle: {
    width: 96,
    height: 96,
    borderRadius: '50%',
    border: '8px solid #0f89e6',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5fbff',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
  },
  ppiScoreLabel: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
  },
  ppiBars: {
    flex: 1,
    minWidth: 220,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  ppiBarRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  ppiBarLabels: {
    flex: '0 0 72px',
    fontSize: theme.typography.pxToRem(13),
  },
  ppiBarTrack: {
    flex: 1,
    height: 8,
    borderRadius: 999,
    backgroundColor: '#e5e5e5',
    overflow: 'hidden',
  },
  ppiBarFill: {
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#5eba6d',
    transition: 'width 0.3s ease',
  },
  ppiBarMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(12),
  },
  ppiInfoDot: {
    width: 18,
    height: 18,
    borderRadius: '50%',
    border: '1px solid #d0d0d0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
  },
  ppiSummaryRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
  },
  ppiSummaryCard: {
    flex: '1 1 140px',
    minWidth: 140,
    borderRadius: 10,
    backgroundColor: '#f8f8f8',
    padding: theme.spacing(1.5, 2),
    fontSize: theme.typography.pxToRem(12),
  },
  ppiSummaryTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  ppiSummaryValue: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
  },
  ppiSummarySub: {
    marginTop: theme.spacing(0.5),
  },
  ppiTable: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    fontSize: theme.typography.pxToRem(12),
    marginTop: theme.spacing(1.5),
  },
  ppiTableHeadCell: {
    padding: theme.spacing(1),
    textAlign: 'left' as const,
    borderBottom: '1px solid #e0e0e0',
    fontWeight: 700,
    backgroundColor: '#fafafa',
  },
  ppiTableCell: {
    padding: theme.spacing(0.75, 1),
    borderBottom: '1px solid #f0f0f0',
  },
  ppiTableHighlightCell: {
    backgroundColor: '#e8f7e9',
    fontWeight: 600,
  },
  ppiTextSection: {
    marginTop: theme.spacing(2),
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.5,
  },
  ppiTextTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },
  ppiBullet: {
    marginLeft: theme.spacing(2),
  },
}), { name: PPIChartsData.name });

export default function PPIChartsData(props: PPIChartsDataProps) {
  const { className, player, collegeTeam, onYearClick, isNFL } = props;
  const classes = useStyles();

  const yearScores = 
//   MOCKED_API_RESPONSE.map(response => response.year);
  [
    { year: 2025, score: 3.7 },
    { year: 2024, score: 3.4 },
    { year: 2023, score: 2.6 },
    { year: 2022, score: 2.5 },
  ];

  const [selectedYear, setSelectedYear] = useState<number>(yearScores[0].year);

  function handleYearClick(year: number) {
    setSelectedYear(year);
    if (onYearClick) onYearClick(year);
  }

  const selectedYearData = MOCKED_API_RESPONSE.find((year) => year.year === selectedYear);
  const selectedYearPPIData = selectedYearData?.ppis || [];

  function renderPPIStats (index: number, name: string, stat: UpdatedPlayerPPIStats) {
    return (
        <Accordion
        key={name}
        summary={`${selectedYearData?.year} ${name}`}
        expanded={index === 0}
      >
        <>
            {true && (
                <Ranks
                headerItems={[
                    { title: 'HS Class', subtitle: `(${2020})` },
                    { title: 'Division-I', subtitle: '(Since 2010)' },
                    { logo: collegeTeam?.logo247 || collegeTeam?.logoESPN || collegeTeam?.logoAlt },
                    { logo: get(collegeTeam, 'conference.iconUrl', '') },
                    { logo: '/images/nfl-draft.png' },
                ]}
                />
            )}
            <Ranks
                key={`${selectedYearData?.year} ${name}`}
                type={RanksType.PAI}
                playerId={player?.id}
                teamId={collegeTeam?.id}
                values={[
                    {
                      percentile: Math.round(get(stat, 'hsClassStats.percentile', 0)),
                      value: `${get(stat, 'hsClassStats.playerRank', 0)}/${get(stat, 'hsClassStats.playerCount', 0)}`,
                    },
                    {
                      percentile: Math.round(get(stat, 'div1Stats.percentile', 0)),
                      value: `${get(stat, 'div1Stats.playerRank', 0)}/${get(stat, 'div1Stats.playerCount', 0)}`,
                    },
                    {
                      percentile: Math.round(get(stat, 'teamStats.percentile', 0)),
                      value: `${get(stat, 'teamStats.playerRank', 0)}/${get(stat, 'teamStats.playerCount', 0)}`,
                      comparisonGroup: RanksComparisonGroup.COLLEGE_TEAM,
                    },
                    {
                      percentile: Math.round(get(stat, 'conferenceStats.percentile', 0)),
                      value: `${get(stat, 'conferenceStats.playerRank', 0)}/${get(stat, 'conferenceStats.playerCount', 0)}`,
                      comparisonGroup: RanksComparisonGroup.COLLEGE_CONFERENCE,
                    },
                    {
                      percentile: Math.round(get(stat, 'nflDraftStats.percentile', 0)),
                      value: `${get(stat, 'nflDraftStats.playerRank', 0)}/${get(stat, 'nflDraftStats.playerCount', 0)}`,
                      comparisonGroup: RanksComparisonGroup.NFL_DRAFT,
                    },
                  ]}
                bottomSpace
                noTopBorder
            />
            {/* PPI detail UI */}
            <div className={classes.ppiWrapper}>
              <div className={classes.ppiTopRow}>
                {/* Score circle and factor bars */}
                <div className={classes.ppiScoreCircle}>
                  <div>{stat.value.toFixed(1)}</div>
                  <div className={classes.ppiScoreLabel}>PPI</div>
                </div>

                <div className={classes.ppiBars}>
                  {(stat.factors || []).map((factor, idx) => {
                    const ratio = factor.total ? factor.value / factor.total : 0;
                    const width = `${Math.min(100, Math.max(0, ratio * 100))}%`;
                    return (
                      <div key={`${factor.name}-${idx}`} className={classes.ppiBarRow}>
                        <div className={classes.ppiBarLabels}>{factor.name}</div>
                        <div className={classes.ppiBarTrack}>
                          <div className={classes.ppiBarFill} style={{ width }} />
                        </div>
                        <div className={classes.ppiBarMeta}>
                          <span>{factor.value.toFixed(1)}</span>
                          <span className={classes.ppiInfoDot}>i</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Summary cards */}
              <div className={classes.ppiSummaryRow}>
                <div className={classes.ppiSummaryCard}>
                  <div className={classes.ppiSummaryTitle}>{selectedYearData?.year} Rank</div>
                  <div className={classes.ppiSummaryValue}>#{stat.hsClassStats?.playerRank ?? 0}</div>
                  <div className={classes.ppiSummarySub}>
                    out of {stat.hsClassStats?.playerCount ?? 0} players
                  </div>
                </div>
                <div className={classes.ppiSummaryCard}>
                  <div className={classes.ppiSummaryTitle}>Percentile</div>
                  <div className={classes.ppiSummaryValue}>
                    {Math.round(stat.prcentileFBS ?? 0)}%
                  </div>
                  <div className={classes.ppiSummarySub}>in FBS</div>
                </div>
                <div className={classes.ppiSummaryCard}>
                  <div className={classes.ppiSummaryTitle}>Utilization</div>
                  <div className={classes.ppiSummaryValue}>{stat.utilizationType ?? 'Medium'}</div>
                  <div className={classes.ppiSummarySub}>
                    {stat.utilization ?? 0} snaps
                  </div>
                </div>
                <div className={classes.ppiSummaryCard}>
                  <div className={classes.ppiSummaryTitle}>Versatility</div>
                  <div className={classes.ppiSummaryValue}>Low</div>
                </div>
              </div>

              {/* Position group table (mocked from stat) */}
              <table className={classes.ppiTable}>
                <thead>
                  <tr>
                    <th className={classes.ppiTableHeadCell}>Position Group</th>
                    <th className={classes.ppiTableHeadCell}>Overall PPI</th>
                    <th className={classes.ppiTableHeadCell}>Plays</th>
                    <th className={classes.ppiTableHeadCell}>Run Defense</th>
                    <th className={clsx(classes.ppiTableHeadCell, classes.ppiTableHighlightCell)}>Pass Coverage</th>
                    <th className={classes.ppiTableHeadCell}>Pass Rush</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Using single stat as mock Safety row */}
                  <tr>
                    <td className={classes.ppiTableCell}>Safety</td>
                    <td className={classes.ppiTableCell}>{stat.value.toFixed(1)}</td>
                    <td className={classes.ppiTableCell}>{stat.utilization ?? 0}</td>
                    <td className={classes.ppiTableCell}>
                      {(stat.factors?.[0]?.value ?? 0).toFixed(1)}
                    </td>
                    <td className={clsx(classes.ppiTableCell, classes.ppiTableHighlightCell)}>
                      {(stat.factors?.[1]?.value ?? 0).toFixed(1)}
                    </td>
                    <td className={classes.ppiTableCell}>
                      {(stat.factors?.[2]?.value ?? 0).toFixed(1)}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* Text sections */}
              <div className={classes.ppiTextSection}>
                <div className={classes.ppiTextTitle}>Player Factors:</div>
                <div className={classes.ppiBullet}>
                  Played the #120 hardest offenses (out of 842 players).
                </div>
                <div className={classes.ppiBullet}>
                  Played on the #1 best defense (out of 842 players).
                </div>
              </div>

              <div className={classes.ppiTextSection}>
                <div className={classes.ppiTextTitle}>Team Factors:</div>
                {(stat.teamFactors || []).map((line: string, idx: number) => (
                  <div key={idx} className={classes.ppiBullet}>{line}</div>
                ))}
              </div>
            </div>
        </>
      </Accordion>
    )
  }

  return (
    <>
        <div className={classes.yearsContainer}>
          {yearScores.map(({ year, score }) => (
            <button
              key={year}
              type="button"
              className={clsx(
                classes.yearButton,
                selectedYear === year && classes.yearButtonSelected,
              )}
              onClick={() => handleYearClick(year)}
            >
              <span className={classes.yearLabel}>{year}</span>
              <span className={classes.scorePill}>{score}</span>
            </button>
          ))}
        </div>
        <div>
        {selectedYearPPIData.map((stat: any, index) => (
            <div key={index}>
                {renderPPIStats(index, stat.name, stat)}
            </div>
        ))}
        </div>
    </>
  );
}